import * as React from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { COLOR } from 'constant'
import { SvgCarretDownIcon } from 'components/common/LeftPanel/LeftPanel.styled'

const useStyles = makeStyles({
  option: {
    '&:hover': {
      backgroundColor: `${COLOR.TEXT} !important`,
    },
  },
})

const SearchDropdown: React.FC<{
  value: any
  id: string
  size: any
  width?: number
  height?: number
  fontSize?: number
  handleStateUpdate?: Function
  isTableView?: boolean
  data: { value: string | number; isDisabled: boolean }[]
  disablePortal?: boolean
}> = ({
  value,
  width = 220,
  height = 40,
  handleStateUpdate = () => {},
  data,
  id,
  size,
  fontSize = 16,
  disablePortal = true,
}) => {
  const onChange = (event: React.SyntheticEvent, valueParam: any) => {
    handleStateUpdate(event, valueParam)
  }
  const styles = useStyles()

  return (
    // <div style={{ zIndex: 2 }}>
    <Autocomplete
      disablePortal={disablePortal}
      id={id}
      popupIcon={<SvgCarretDownIcon iconColor={COLOR.CARRET} width='20px' height='20px' />}
      size={size}
      classes={{
        option: styles.option,
      }}
      disableClearable
      sx={{
        mx: 0,
        my: 1,
        width: width,
        position: 'relative',
        '& .MuiAutocomplete-inputRoot': {
          border: `1px solid ${COLOR.DARK}`,
          height: `${height}px !important`,
          borderRadius: '30px !important',
          fontSize: `${fontSize}px !important`,
          fontFamily: 'CircularStdBook !important',
          paddingTop: height < 40 ? '3px !important' : '6px !important',
        },
        '& .MuiAutocomplete-popupIndicator': {
          transform: 'none',
          background: 'transparent',
          marginTop: '2px',
          '&:focus, &:active': {
            transform: 'rotate(90deg)',
            background: 'transparent',
          },
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
        '& .MuiAutocomplete-popupIndicatorOpen': {
          transform: 'rotate(90deg)',
        },
      }}
      value={value}
      onChange={onChange}
      options={data.map((el) => el.value)}
      getOptionDisabled={(option) => {
        return data.find((el) => el.value === option)?.isDisabled || false
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            style: { fontSize: fontSize },
          }}
          value={value}
        />
      )}
    />
    // </div>
  )
}
export default SearchDropdown
